import { createAsyncThunk } from '@reduxjs/toolkit';
import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import {
  ByIdParams,
  ByDocumentIdParams,
  GetDocumentParams,
  CreateDocumentParams,
} from '../types';

const getDocuments = createAsyncThunk<any, GetDocumentParams>(
  `/getDocuments`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(`${endPoints.document.mainV2}`, {
        params,
      });
      return {
        list: response.data.data,
        pagination: {
          current: params.page,
          pageSize: params.size,
          total: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const updateDocument = createAsyncThunk<any, ByDocumentIdParams>(
  `/updateDocument`,
  async ({ documentId, params }, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.put(
        `${endPoints.document.main}/${documentId}`,
        params,
      );
      return response.data.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const verifyDocument = createAsyncThunk<any, ByDocumentIdParams>(
  `/verifyDocument`,
  async ({ documentId, params }, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.put(
        `${endPoints.document.main}/${documentId}/verify`,
        params,
      );
      return {
        data: response.data.data,
        countDocumentIDPending: response.data.countDocumentIDPending,
      };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const createDocument = createAsyncThunk<any, CreateDocumentParams>(
  `/createDocument`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post(
        `${endPoints.document.main}`,
        params,
      );
      return response.data.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const deleteDocument = createAsyncThunk<any, ByIdParams>(
  `/deleteDocument`,
  async ({ id: documentId }, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.delete(
        `${endPoints.document.main}/${documentId}`,
      );
      return { id: documentId, success: response.data.success };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const getDocumentsById = createAsyncThunk<any, ByIdParams>(
  `/getDocumentsById`,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        `${endPoints.employee.document}/${id}`,
        { params },
      );

      return {
        list: response.data.data,
        pagination: {
          current: params.page,
          pageSize: params.size,
          total: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const getDocumentById = createAsyncThunk<any, ByIdParams>(
  `/getDocumentById`,
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(`${endPoints.document.main}/${id}`);
      return response.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const documentAct = {
  getDocuments,
  verifyDocument,
  updateDocument,
  deleteDocument,
  createDocument,
  getDocumentsById,
  getDocumentById,
};
